const headerStr = `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>电子手册生成</title>
    <style>
        * {
            margin: 0;
            padding: 0;
            font-family: 'PingFang SC', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif;
        }
    </style>
</head>
<body>`;

const footerStr = `</body></html>`;

export const getAlbumDigtalHandle = (pageViewList) => {
    let contentStr = `<div style="width: 595px;">`;
    for (let i = 0; i < pageViewList.length; i++) {
        const ratio = 595 / pageViewList[i].width;
        contentStr += `<div style="position: relative; width: 595px; height: 842.5px; background-image: url(${pageViewList[i].background_image.url}); background-repeat: no-repeat; background-position: center center; background-size: cover;">`
        for (let j = 0; j < pageViewList[i].section_views.length; j++) {
            const fieldViews = pageViewList[i].section_views[j].field_views;
            for (let k = 0; k < fieldViews.length; k++) {
                const { width, height, top, left, type, style, value, image } = fieldViews[k];
                const { alignment, font_color, font_size, font_weight, line_height, max_lines, rotate, border_color, border_radius, border_with } = style;
                contentStr += `<div style="position: absolute;top:${top * ratio}px;left:${left * ratio}px;width: ${width * ratio}px;height: ${height * ratio}px;overflow:hidden;transform: rotate(${rotate || 0}deg);-webkit-transform:rotate(${rotate || 0}deg);`;
                if (type === "text") {
                    let _color = font_color ? `#${font_color.toString(16).slice(2)}` : "#515151";
                    contentStr += `font-size:${font_size * ratio}px;line-height:${line_height};font-weight: ${font_weight};color:${_color};`;
                    if (max_lines === 1) {
                        contentStr += `display: table;"><span style="display: table-cell; vertical-align: middle;`;
                        if (alignment.endsWith("center")) {
                            contentStr += "text-align: center;";
                        }
                        contentStr += `">${value || ""}</span></div>`;
                    } else {
                        contentStr += `">${value || ""}</div>`;
                    }
                    continue;
                }

                if (image) {
                    contentStr += `background-image: url(${image.compressed_url}); background-repeat: no-repeat; background-position: center center; background-size: cover;`;
                }

                if (border_with) {
                    contentStr += `border: ${border_with}px solid #${border_color.toString(16)};`;
                }


                if (border_radius) {
                    contentStr += `border-radius: ${border_radius * ratio}px;`;
                }
                contentStr += `"></div>`;
            }
        }
        contentStr += "</div>";
    }
    contentStr += "</div>";
    return headerStr + contentStr + footerStr
}